import { useQuery } from '@apollo/client';

import { ROLES } from '../graphql/query/rolesQuery.graphql';

export const useRolesQuery = () => {
  return useQuery(ROLES);
};
